// @flow

import React from 'react';
import type {SizeScale} from 'sail/types';
import {BodyAlt} from 'sail/Text';
import {InlineLink} from 'sail/InlineLink';
import {FormattedMessage} from 'react-intl';
import {headerMessages} from './Header.messages';

export const SupportLink = ({size = 'large'}: {size?: SizeScale}) => {
  return (
    <BodyAlt>
      <InlineLink
        color="gray700"
        href="https://support.stripe.com/"
        target="_blank"
      >
        <FormattedMessage {...headerMessages.support} />
      </InlineLink>
    </BodyAlt>
  );
};
